import _extends from "babel-runtime/helpers/extends";
var render = function render() {
          var _vm = this,
              _c = _vm._self._c;return _c('popover', { ref: "popover", attrs: { "popoverProps": _vm.popoverProps }, scopedSlots: _vm._u([{ key: "reference", fn: function fn(_ref) {
                                        var _show = _ref.show,
                                            hide = _ref.hide;
                                        return [_c('span', { ref: "reference", staticStyle: { "display": "inline-block" } }, [_vm._t("reference", null, { "show": function show(src, type) {
                                                            return _vm.showSource(src, type, _show);
                                                  }, "hide": hide })], 2)];
                              } }], null, true) }, [_c('div', { class: ['image', { 'dark': _vm.type === 'effect' }] }, [_vm._t("default", function () {
                    return [_vm.isImage ? _c('el-image', _vm._b({ staticClass: "preview-image", attrs: { "src": _vm.src } }, 'el-image', _extends({
                              fit: 'scale-down'
                    }, _vm.previewProps), false), [_c('div', { staticClass: "error-icon", attrs: { "slot": "error" }, slot: "error" }, [_c('i', { staticClass: "el-icon-picture-outline" })])]) : _vm.isXlz ? _c('frame-sequence', { attrs: { "images": _vm.src } }) : _vm._e()];
          })], 2)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };